const PropTypes = require("prop-types");
const Element = require("components/abstract/Element");

class Action extends Element {

	/////////////////////////////////
	// Statics
	/////////////////////////////////

	static get propTypes() {
		return {
            action: PropTypes.func,
            onClick: PropTypes.func,
            type: PropTypes.string
		};
	}

	/////////////////////////////////
	// Event handlers
	/////////////////////////////////

	onAction(){
		if (this.props.onClick && typeof this.props.onClick === "function") {
			return this.props.onClick(...arguments);
		}
		if (this.props.action && typeof this.props.action === "function") {
			return this.props.action(...arguments);
		}
		if (this.props.onAction && typeof this.props.onAction === "function") {
			return this.props.onAction(...arguments);
		}
	}
		
	_onAction = () => {
		//
	}

}

module.exports = Action;
